import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { noop } from 'lodash-es';
import { ChatMessages } from './chat-messages';
import { useChatScroll } from './use-chat-scroll';
import { createElementScrollStrategy } from './scroll-strategies';

export function ElementScrollChatMessages({
  className = null,
  header = null,
  messages,
  isChatInProgress = false,
  setLoading,
  onLinkClick,
  onMCPLinkClick,
  customMarkdownComponents = null,
  onAiMessageComplete = noop,
  isSemTest,
  messagesContainerRef = null,
  messagesRef = null,
  onStreamStateChange = noop,
  onSubmit = noop,
  inputRef,
  suggestedMessage = null,
  isMobile = false,
}) {
  const elementScrollStrategyInstance = useMemo(
    () => createElementScrollStrategy(messagesContainerRef, messagesRef),
    [messagesContainerRef, messagesRef]
  );

  useChatScroll({
    isChatInProgress,
    scrollStrategy: elementScrollStrategyInstance,
    messages,
  });

  return (
    <ChatMessages
      className={classnames('overflow-y-auto', className)}
      header={header}
      messages={messages}
      setLoading={setLoading}
      onLinkClick={onLinkClick}
      onMCPLinkClick={onMCPLinkClick}
      customMarkdownComponents={customMarkdownComponents}
      onAiMessageComplete={onAiMessageComplete}
      isSemTest={isSemTest}
      messagesContainerRef={messagesContainerRef}
      messagesRef={messagesRef}
      onStreamStateChange={onStreamStateChange}
      onSubmit={onSubmit}
      inputRef={inputRef}
      suggestedMessage={suggestedMessage}
      isMobile={isMobile}
    />
  );
}

ElementScrollChatMessages.propTypes = {
  ...ChatMessages.propTypes,
  isChatInProgress: PropTypes.bool,
  onSubmit: PropTypes.func,
  inputRef: PropTypes.shape({}).isRequired,
  isMobile: PropTypes.bool,
};
